import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '@lushdigital/icons';

// import './style.scss'; // TODO - move this styling somewhere?

class InlineMenu extends Component {
  constructor(props) {
    super(props);
    this.state = { inlineMenu: false };
    this.inlineMenuContainer = null;
    this.Wrapper = React.createRef();
  }

  componentDidMount() {
    const { onGetRef } = this.props;

    this.Wrapper.current.focus();

    if (typeof onGetRef === 'function') onGetRef(this.inlineMenuContainer);
  }

  handleClick(e) {
    const target = e.target.className;
    if (typeof target === 'string') {
      if (target.includes('ui-inline-menu__row')) {
        this.setState({ inlineMenu: false });
      }
    }
  }

  toggleInlineMenu = () => {
    this.setState({ inlineMenu: !this.state.inlineMenu });
  };

  handleBlur = (e) => {
    const { currentTarget } = e;

    this.tick = setTimeout(() => {
      if (!currentTarget.contains(document.activeElement) && this.Wrapper.current !== document.activeElement) {
        this.setState({ inlineMenu: false });
      }
    }, 0);
  };

  renderChildren() {
    const { children, data } = this.props;

    const childrenWithProps = React.Children.map(children, (child) => {
      if (child !== null) {
        return React.cloneElement(child, { data, toggle: this.toggleInlineMenu });
      }
    });

    return childrenWithProps;
  }

  render() {
    const { mobile, context, className } = this.props;

    let setContext = context;
    if (context === 'table' && mobile) {
      setContext = 'table--card';
    }

    return (
      <div
        className={`ui-inline-menu ui-inline-menu--${setContext} ${
          className !== '' ? `inline-menu-${className}` : ''
        } ${this.state.inlineMenu ? 'is-active' : ''}`}
        onClick={(e) => this.handleClick(e)}
        ref={this.Wrapper}
        onBlur={this.handleBlur}
      >
        <div className={`ui-inline-menu__wrapper ${className !== '' ? `inline-menu-${className}__wrapper` : ''} `}>
          {/* Container of buttons */}
          <div
            className={`ui-inline-menu__container ${className !== '' ? `inline-menu-${className}__container` : ''}`}
            ref={(inlineMenuContainer) => {
              this.inlineMenuContainer = inlineMenuContainer;
            }}
          >
            {this.renderChildren()}
          </div>

          {/* Toggle button (Open/Close) */}
          <button
            className={`ui-inline-menu__toggle ${className !== '' ? `inline-menu-${className}__toggle` : ''} `}
            onClick={() => {
              this.toggleInlineMenu();
            }}
          >
            <Icon fill="#fff" icon="more-vert" size="18px" />
          </button>
        </div>
      </div>
    );
  }
}

InlineMenu.defaultProps = {
  children: '',
  className: '',
  context: 'float',
  onGetRef: null,
  data: null
};

InlineMenu.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  context: PropTypes.string,
  onGetRef: PropTypes.func,
  data: PropTypes.object
};

InlineMenu.displayName = 'InlineMenu';

export default InlineMenu;
